exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotFound {\n  margin-top: 60px;\n  display: grid;\n  justify-content: center;\n  align-content: center;\n  text-align: center;\n  padding: 1em;\n}\n.NotFound h2 {\n  font-size: 8em;\n  padding: 10px;\n  font-weight: 100;\n  color: #007bff;\n}\n.NotFound h6 {\n  font-weight: 900;\n  padding: 0.5em;\n  font-size: 2em;\n  color: #545454;\n}\n.NotFound small {\n  max-width: 400px;\n  font-weight: 300;\n  color: #545454;\n  padding: 0.51em;\n}\n", ""]);

// exports
